if (!customElements.get('flagship-store')) {
  class FlagshipStore extends HTMLElement {
    constructor() {
      super();
      this.toggleBtn = this.querySelector('[data-map-button]');
      this.media = this.querySelector('.flagship-store__media');
      this.slideshow = this.querySelector('.flagship-store__slideshow');
      this.map = this.querySelector('.flagship-store__map');
      this.isVisible = false;

      this.handleClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.toggleBtn.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.toggleBtn.removeEventListener('click', this.handleClick)
    }

    onClick() {
      this.isVisible ? this.hide() : this.show();
    }

    show() {
      this.isVisible = true;
      this.media.classList.add('active');
      this.toggleBtn.innerText = 'Images';
    }

    hide() {
      this.isVisible = false;
      this.media.classList.remove('active');
      this.toggleBtn.innerText = 'Map';
    }
  }

  customElements.define('flagship-store', FlagshipStore);
}